export default __webpack_public_path__ + "static/extra-aeab96fc29c4f3ec4c20f8dd2e3e7812.png";